import type { JSX } from 'preact';
import { GRID_BASE_M, metersToPixels } from '../sim/constants.ts';
import './scale-meter.css';

/** Width is one grid cell, so the bar always measures exactly what the label says. */
export function ScaleMeter({ label }: { label: string }): JSX.Element {
  return (
    <div class="ui-scale" style={{ width: `${metersToPixels(GRID_BASE_M)}px` }}>
      <span class="ui-scale-label">{label}</span>
      <span class="ui-scale-bar" aria-hidden="true" />
    </div>
  );
}
